import { AppStoreTypeImt } from 'store';

export const selectIsOpenRecommendedFieldsModal = (state: AppStoreTypeImt) => {
  return state.getIn(['modals', 'recommendedFieldsModalState', 'isOpenRecommendedFieldsModal']);
};
export const selectIsSubmittedRecommendedFieldsModal = (state: AppStoreTypeImt) => {
  return state.getIn(['modals', 'recommendedFieldsModalState', 'isSubmitted']);
};
